import React from 'react';
import { CheckIcon, ChevronRightIcon, PackageIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { volumes, extras, journeySteps } from '../../data/content';
export function WhatsInside() {
  return <section className="bg-ink-950 py-12 sm:py-16" aria-labelledby="inside-title" data-id="element-316" data-mp="1lia7rvgd4dgu">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-317" data-mp="1gl9zddw1iymk">
        <h2 id="inside-title" className="flex flex-col items-center gap-2 text-center font-display text-[1.75rem] font-extrabold uppercase leading-[1.02] text-white sm:text-4xl" data-id="element-318" data-mp="1ciwwqyclbgu0">
          <PackageIcon className="h-8 w-8 text-gold-500" aria-hidden="true" data-id="element-319" data-mp="12kh58u9ni5jz" />
          What’s inside the Premium Technician Kit™?
        </h2>

        <div className="mt-8 space-y-5" data-id="element-320" data-mp="xmxpfpxb1kpx">
          {volumes.map(vol => <article key={vol.label} className="overflow-hidden rounded-2xl border border-white/10 bg-ink-900" data-id="element-321" data-mp="2wz09p2dr6j4n">
              <div className="border-b border-white/10 bg-gold-500 px-4 py-3" data-id="element-322" data-mp="2rxuf0z0j8lsh">
                <p className="font-display text-xs font-extrabold uppercase tracking-[0.2em] text-ink-950/70" data-id="element-323" data-mp="1kndbrzdms6jk">
                  {vol.label}
                </p>
                <h3 className="font-display text-xl font-extrabold uppercase leading-tight text-ink-950 sm:text-2xl" data-id="element-324" data-mp="1aradj4lwgs1w">
                  {vol.title}
                </h3>
              </div>
              <div className="p-4 sm:p-5" data-id="element-325" data-mp="23emosimm1dfw">
                <p className="font-semibold text-gold-400 sm:text-lg" data-id="element-326" data-mp="23fo8tcllta9r">{vol.hook}</p>
                <p className="mt-2 text-sm leading-relaxed text-steel-300 sm:text-base" data-id="element-327" data-mp="28cxymtcwnny4">
                  {vol.body}
                </p>
                <ul className="mt-4 grid gap-x-5 gap-y-1.5 sm:grid-cols-2" data-id="element-328" data-mp="1tnijybqnf8ys">
                  {vol.items.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-snug text-white sm:text-[15px]" data-id="element-329" data-mp="2meaaasl193e7">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-400" aria-hidden="true" data-id="element-330" data-mp="310qw50bc878c" />
                      <span data-id="element-331" data-mp="2w2fq70o5ygve">{item}</span>
                    </li>)}
                </ul>
                {vol.label === 'VOLUME VI' && <p className="mt-4 rounded-lg border-l-4 border-gold-500 bg-white/[0.05] px-3 py-2.5 text-sm text-steel-300" data-id="element-332" data-mp="2n1r6pqg03ob4">
                    Customize them with your business name, logo, contact
                    information, and service details — then start using them.
                  </p>}
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-333" data-mp="24b03z7qiqw5p">
          <h3 className="text-center font-display text-2xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-334" data-mp="24brlxfr70vdi">
            And you’ll also get:
          </h3>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-335" data-mp="1uckbp1fr9gum">
            {extras.map(extra => <li key={extra.title} className="rounded-xl border border-white/10 bg-ink-900 p-4" data-id="element-336" data-mp="9urmtzxd3uy7">
                <span className="text-2xl" aria-hidden="true" data-id="element-337" data-mp="eri24l1cemik">
                  {extra.emoji}
                </span>
                <h4 className="mt-2 font-display text-base font-extrabold uppercase leading-tight text-gold-400" data-id="element-338" data-mp="jql7k6l8iur2">
                  {extra.title}
                </h4>
                <p className="mt-1.5 text-sm leading-snug text-steel-300" data-id="element-339" data-mp="3naple989297l">
                  {extra.text}
                </p>
              </li>)}
          </ul>
        </div>

        <div className="mt-10 rounded-2xl border border-gold-500/30 bg-ink-900 p-5 sm:p-7" data-id="element-340" data-mp="3dovwl27376">
          <p className="text-center font-display text-lg font-bold uppercase leading-tight text-steel-300 sm:text-xl" data-id="element-341" data-mp="4w6vyr402nmf">
            Any customer who contacts you…
          </p>
          <p className="mt-1 text-center font-display text-xl font-extrabold uppercase leading-tight text-gold-500 sm:text-2xl" data-id="element-342" data-mp="38k04cq83xzvt">
            …can now go through a clearer, more professional service experience.
          </p>

          <ol className="mt-5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-2" data-id="element-343" data-mp="2khlef3ncb8ib">
            {journeySteps.map((step, i) => <li key={step} className="flex items-center gap-1.5" data-id="element-344" data-mp="2z7j9m3josyh0" data-mpi={i}>
                <span className="rounded-md bg-white/[0.07] px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-white sm:text-xs" data-id="element-345" data-mp="2udy9o5yj9uf6">
                  {step}
                </span>
                {i < journeySteps.length - 1 && <ChevronRightIcon className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-346" data-mp="3i4antykdgne7" />}
              </li>)}
          </ol>
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-347" data-mp="1nphvc8esccqh">
          <CTAButton label="I want the complete professional system" sub="6 volumes + 5 bonuses for $27 USD" size="md" data-id="element-348" data-mp="1nsdsvvmq0zee" />
        </div>
      </div>
    </section>;
}